module.exports = __webpack_public_path__ + "static/image/service/m/store@3x.jpg?94d66196";